import {
  IAdditional,
  IAdditionalHeaderProps,
} from "../../TableTemplate/tableTemplate";
import { TableCell } from "@mui/material";
import { useState } from "react";
import { OrderStatus } from "../../../Interfaces/orderInterfaces";
import { toast } from "react-toastify";
import { packetErrorHandler } from "../../../Utils/requestUtils";
import DeleteIcon from "@mui/icons-material/Delete";
import FullScreenLoading from "../../../Components/Loading/FullScreenLoading";
import { cancelMarketmakingOrder } from "../../../Requests/deltaHedgeMarketmaking";
import { IMarketmakingOrderTableReport } from "../../../Interfaces/deltaHedgeMarketmaking";

const MarketmakingOrderTableAdditionalHeader = ({}: IAdditionalHeaderProps) => {
  const [loading, setLoading] = useState(false);

  return (
    <>
      {loading ? <FullScreenLoading /> : <></>}
      <TableCell></TableCell>
    </>
  );
};

const MarketmakingOrderTableAdditionalCol: React.FC<{
  row: IMarketmakingOrderTableReport;
  onAction: () => void;
}> = ({ row, onAction }) => {
  const cancelOrderHandler = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    e.stopPropagation();
    cancelMarketmakingOrder(row.id)
      .then((resp) => {
        if (resp.data) {
          onAction();
          toast.success(resp.msg);
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler);
  };

  return (
    <>
      <TableCell>
        {row.orderStatus !== OrderStatus.Cancelled ? (
          <div
            onClick={cancelOrderHandler}
            className="hover:bg-red-100 transition-all rounded p-1"
          >
            <DeleteIcon
              fontSize="small"
              className="text-red-700 cursor-pointer"
            />
          </div>
        ) : null}
      </TableCell>
    </>
  );
};

export const MarketmakingOrderTableAdditional: IAdditional<IMarketmakingOrderTableReport> =
  {
    getHeader: MarketmakingOrderTableAdditionalHeader,
    getRow: MarketmakingOrderTableAdditionalCol,
  };
